var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.551 12.992v-1.687h14.173v1.687H.551Zm0-5.062V6.243h14.173V7.93H.551Zm0-5.062V1.181h14.173v1.687H.551Z",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.516 1.968a1.468 1.468 0 1 1-2.937 0 1.468 1.468 0 0 1 2.937 0ZM14.5 7.087a1.469 1.469 0 1 1-2.937 0 1.469 1.469 0 0 1 2.937 0ZM3.437 12.205a1.469 1.469 0 1 1-2.937 0 1.469 1.469 0 0 1 2.937 0Z",
    fill: "#fff"
  })));
};
export default SvgFilter;